import { Modal } from '~/components/modals/CurieModal'
import { bridge } from '~/services/bridge'
import { PlanComponent } from './PlanDialog'

interface ZeroCreditsDialogProps {
  isOpen: boolean
  onClose: () => void
}

export default function ZeroCreditsDialog({ isOpen, onClose }: ZeroCreditsDialogProps) {
  const isPlugin = bridge.isInPlugin()
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={
        isPlugin
          ? 'max-w-[calc(100vw-24px)] w-full h-[calc(100vh-32px)] overflow-hidden'
          : 'min-w-[636px] max-w-[840px] w-full h-[calc(100vh-120px)] overflow-hidden'
      }
      overlayClassName={isPlugin ? 'px-3' : 'px-[48px]'}
      hideCloseButton={false}
      disableOutsideClick
      rawContent
    >
      <PlanComponent onClose={onClose} defaultTab='credits' isCheckoutActive={isOpen} />
    </Modal>
  )
}
